import { useAuthenticationStore } from "../stores/authentication"

export default () => {
  const auth = useAuthenticationStore()

  if (!(auth.user && auth.user?.email)) {
    const currentRoute = window.location.pathname + window.location.search + window.location.hash

    if (currentRoute !== '/authentication') {
      sessionStorage.setItem("redirectAfterLogin", currentRoute)

      const establishmentId = new URLSearchParams(window.location.search).get("establishment")
      if (establishmentId) {
        sessionStorage.setItem("requestedEstablishmentId", establishmentId)
      }
    }

    return {
      success: false,
      path: "/authentication",
    }
  }
  return {
    success: true,
  }
}
